(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('Disease', Disease);

    Disease.$inject = ['$resource'];

    function Disease ($resource) {
        var resourceUrl =  'api/diseases/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
